<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 class="">OBJEDNÁVKY</h2>
        <router-link to="/mod-orders/order/0" >
          <PrimevueButton label="Pridať objednávku" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
        </router-link>
      </div>
      <DataTable
          :rowStyle="rowStyle"
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.orders"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          v-model:selection="this.selectedOrder"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="showDetail(this.selectedOrder.id)"
          tableStyle="min-width: 50rem"
          :virtualScrollerOptions="{ itemSize: 40 }"
      >
        <template #header>
          <div class="flex justify-content-end">
            <IconField iconPosition="left">
              <InputIcon>
                <i class="pi pi-search mr-2"/>
              </InputIcon>
              <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
            </IconField>
          </div>
        </template>

        <Column field="orderCode" header="ID"
                filterField="orderNumber"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 12%">
          <template #body="slotProps">
            {{ slotProps.data.orderCode }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>
        
<!--        <Column field="customer.company" header="Firma"-->
<!--                filterField="customerCompany"-->
<!--                :showFilterMenu="false" :filterMenuStyle="{ width: '6rem' }" style="min-width: 15%"-->
<!--                v-if="this.store.user.admin">-->
<!--          <template #body="slotProps">-->
<!--             {{ slotProps.data.customer.company }}-->
<!--          </template>-->
<!--          <template #filter="{ filterModel, filterCallback }">-->
<!--            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"-->
<!--                       placeholder="Hľadať" style="min-width: 10rem"/>-->
<!--          </template>-->
<!--        </Column>-->
<!--        -->
<!--        <Column field="modifiedUser.lastName" header="Objednávku riešil"-->
<!--                filterField="modifiedUserName"-->
<!--                :showFilterMenu="false" :filterMenuStyle="{ width: '6rem' }" style="min-width: 15%"-->
<!--                v-if="this.store.user.admin">-->
<!--          <template #body="slotProps">-->
<!--            {{ slotProps.data.modifiedUser.lastName }} {{ slotProps.data.modifiedUser.firstName }}-->
<!--          </template>-->
<!--          <template #filter="{ filterModel, filterCallback }">-->
<!--            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"-->
<!--                       placeholder="Hľadať" style="min-width: 10rem"/>-->
<!--          </template>-->
<!--        </Column>-->
        
        <Column field="customerName" header="Zákazník"
                filterField="customerName"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '8rem' }" style="min-width: 12%">
          <template #body="slotProps">
            {{ slotProps.data.customerName }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 10rem"/>
          </template>
        </Column>

        <Column header="Popis" field="description" style="min-width: 6%">
        </Column>


        <Column field="state" header="Status" :showFilterMenu="false"
                :filterMenuStyle="{ width: '2rem' }" style="min-width: 2rem">
          <template #body="slotProps"> 
            {{ slotProps.data.state }}
            <!-- <PrimevueTag :value="data.state" /> -->
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <PrimevueSelect v-model="filterModel.value" @change="filterCallback()"
                      :options="statusLabels" optionLabel="label" placeholder="Vyber stav"
                      class="p-column-filter" style="min-width: 6rem" >
              <template #option="slotProps">
                <PrimevueTag :value="slotProps.option.label" :style="{ backgroundColor: slotProps.option.color }"/>
              </template>
            </PrimevueSelect>
          </template>
        </Column>

        <Column header="Neprečítané správy" field="unreadMessages" style="min-width: 6%">
        </Column>

        <Column header="Dátum" style="width: 18%">
          <template #body="slotProps">
            {{ formatDate(slotProps.data.createdAt) }}
          </template>
        </Column>

        <!--
        <Column header="">
          <template #body="slotProps">
            <a  @click="showDetail(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Zobraziť" text raised class="uppercase" icon="pi pi-eye" severity="info"/>
            </a>
          </template>
        </Column> 
        -->
        <Column header="">
          <template #body="slotProps">

            <PrimevueButton type="button" v-tooltip.top="{ value: 'Vymazanie objednávky' }" icon="pi pi-trash" @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>
            <!--
            <a  @click="confirmDelete(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Odstrániť" text raised icon="pi pi-trash" severity="danger"/>
             </a>
             -->
          </template>
        </Column>
      </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

import PrimevueTag from 'primevue/tag';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import PrimevueSelect from "primevue/dropdown";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import Utils from '@/components/utils';
//import {emiter} from '../main';

export default {
  components: {
    DataTable,
    Column,
    PrimevueTag,
    PrimevueSelect,
    IconField,
    InputIcon,
    PrimevueButton

  },
  name: "OrderList",
  data() {
    return {
      store,
      vh: 0,
      selectedOrder: null,
      orders: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customerCompany: {value: null, matchMode: FilterMatchMode.CONTAINS},
        modifiedUserName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        description: {value: null, matchMode: FilterMatchMode.CONTAINS},
        state: {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      filterFields: [  {field: 'OrderCode',value: ""},
                       {field: 'Description',value: ""},
                       {field: 'CustomerId__Company',value: ""},
                       {field: 'CustomerId__LastName',value: ""},
                       {field: 'ModifiedUser__LastName',value: ""},
                       {field: 'CurrentState__Name',value: ""}
                    ],
      globalFilterFields: ['OrderCode', 'CustomerLastName', 'Description', 'CurrentState__Name'],
      statuses: [],
      statusLabels: [],
      loading: true,
      //lazyParams: [],
      pagination: {
        first: 0,
        rows: 50,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },
  beforeMount() {
    if (Security.requireToken()){
      
      store.selectModul = this.$route.path.split("/")[1]
      
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      
      //if (this.$route.path.split("/")[1] != store.selectModul){
      //  router.push({path: store.actualRoute})
      //}
      //store.actualRoute = this.$route.path
      
      this.initFilters()

      if (store.user.admin) {
        this.globalFilterFields = ['OrderCode', 'ModifiedUser__LastName', 'Description', 'CustomerId__Company', 'CustomerLastName', 'CurrentState__Name']
      }

    
      fetch(store.Api_url + "/v1/order-state?query=active:1", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              notie.alert({
                      type: 'error',
                      text: "Zoznam stavov objednávky sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.statuses = responseData.data
              this.statuses.forEach((status) => {
                let stat = {label: status.name, color: status.color}
                this.statusLabels.push(stat)
              });
              this.loading = false
            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam stavov objednávky sa nepodarilo načítať: " + error,
                      position: "top"
                    })           
          });
      
      this.loadComponent()
    }
  },
  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

    rowStyle(data) {
      return { backgroundColor: data.currentState.color };
    },
    
    formatDate(dateString: string): string {
 
      return Utils.parseToSlovakDateTime(dateString);
      
    },
    //buttonClicked(rowData) {
    //  alert(`Button clicked for ${rowData.name}`);
    //},
    // load additional order data and store it in store.order obj
    showDetail(orderId:number) {
      router.push('/mod-orders/order/' + String(orderId))
    },
    confirmDelete(orderId:number) {
      this.$confirm.require({
          message: 'Naozaj chcete vymazať objednávku?',
          header: 'Vymazanie objednávky',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.deleteOrder(orderId)
          },

      });
    },
    deleteOrder(orderId:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/order/" + String(orderId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Objednávku sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {
                // Make a copy of the orders array to avoid mutating during iteration
                const updatedOrders = [...this.orders];

                // Find and remove the order with the matching ID
                const indexToRemove = updatedOrders.findIndex(order => order.id === orderId);
                if (indexToRemove !== -1) {
                  updatedOrders.splice(indexToRemove, 1);
                }

                // Update the UI with the modified orders array
                this.orders = updatedOrders;
                notie.alert({
                  type: 'success',
                  text: "Objednávka bola odstránená",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              alert('chyba pri nacitani objednavok: ' + error)
            })
      //}
    },

    onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.store.basicUrlFilterOrders,this.pagination);
    },
    //onSort(event) {
    //  this.lazyParams = event;
    //  this.loadLazyData(event);
    //},
    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      //console.log('Load component',this.pagination.filters);
      //this.routeByType = Utils.getMessageRoute(this.store.basicUrlFilterOrders,this.routeParams)

      this.loadLazyData(this.store.basicUrlFilterOrders,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "order"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        //this.filters = {
        //  global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //  orderNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //  customerName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //  subject: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //}
    },
    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'OrderCode',value: event.filters.orderNumber.value ? event.filters.orderNumber.value : ""},
                                                    {field: 'CustomerLastName',value: event.filters.customerName.value ? event.filters.customerName.value: ""},
                                                    {field: 'CustomerId__Company',value: event.filters.customerCompany.value ? event.filters.customerCompany.value: ""},
                                                    {field: 'ModifiedUser__LastName',value: event.filters.modifiedUserName.value ? event.filters.modifiedUserName.value: ""},
                                                    {field: 'CurrentState__Name',value: event.filters.state.value ? event.filters.state.value.label : ""}
                                                  ];
           this.pagination.filters.global = event.filters.global.value
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.store.basicUrlFilterOrders,this.pagination);
    },
    loadLazyData(route,params) {
      this.loading = true;

      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("POST",params.filters))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
              //console.error("error:", responseData.message);
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: "Zoznam objednávok sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.orders = responseData.data;
                  this.orders.forEach(order => {
                    if(order.currentState){
                       order.state = order.currentState.name;
                      }else{
                        order.state = ""
                      }
                      if(order.customerLastName){
                       order.customerName = order.customerLastName // order.customerFirstName
                      }else{
                        order.customerName = ""
                      }                      

                  });
                }else{
                    notie.alert({
                    type: 'info',
                    text: "Zoznam objednávok je prázdny",
                    position: "top"
                  })
                  this.orders = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            //alert('Error fetching data: ' + error);
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní objednávok: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>